<div class="container grid-container">
  <app-mines-bet-section />
  <app-mines-board />
</div>
